import React, { createContext, useContext, useState, useEffect } from "react";
import { auth, googleProvider, microsoftProvider, signInWithPopup, signOut } from "../config/firebaseconfig";
import { onAuthStateChanged } from "firebase/auth";
import { toast } from "react-toastify";



const AuthContext = createContext();

const API_URL = process.env.REACT_APP_API_URL;


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState(null);
  


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setLoading(true);
        const accessToken = currentUser.accessToken;
        try {
          const response = await fetch(`${API_URL}/user`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`
            }
          });
        
          if (response.ok) {
            const data = await response.json();
                  
            setUser({
              email: data.email,
              company: data.company,
              companies: data.companies,
              isAdmin: data.isAdmin,
            });
                  
            setToken(accessToken);
                  
          } else {
            console.log("Inloggning nekad!");
            await signOut(auth);
            setUser(null);
            setToken(null);
            toast.error("Du är inte behörig att logga in. Kontakta Community Support på mail: support@communitysverige.se eller telefonnummer: 08-684 330 30 för mer information.");
          }
        } catch (error) {
          console.error("Fel vid kommunikation med backend:", error);
          toast.error("Du är inte behörig att logga in. Kontakta Community Support på mail: support@communitysverige.se eller telefonnummer: 08-684 330 30 för mer information.");
        
      } finally {
        setLoading(false); 
      }
      } else {
        setUser(null);
        setToken(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // Google Login
  const loginWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const accessToken = result.user.accessToken;
   
      setToken(accessToken);
      setAuthError(null);
    } catch (error) {
      setAuthError(error.message);
    }
  };

 
  const loginWithMicrosoft = async () => {
    try {
      
      const result = await signInWithPopup(auth, microsoftProvider);
      const accessToken = result.user.accessToken;
    
      setToken(accessToken);
      setAuthError(null);
  } catch (error) {
    setAuthError(error.message);
  }
};

 
  const logout = async () => {
    await signOut(auth);
    setUser(null);
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, token, loginWithGoogle, loginWithMicrosoft, logout }}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => useContext(AuthContext);


